import { CalendarOffIcon, XIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

const SESSION_KEY = 'summer-break-banner-closed'
const EXPIRY_DATE = new Date('2026-07-19T00:00:00')

export function SummerBreakBanner() {
	const [visible, setVisible] = useState(false)

	useEffect(() => {
		const now = new Date()
		const alreadyClosed = sessionStorage.getItem(SESSION_KEY) === 'true'

		if (!alreadyClosed && now < EXPIRY_DATE) {
			setVisible(true)
		}
	}, [])

	const handleClose = () => {
		sessionStorage.setItem(SESSION_KEY, 'true')
		setVisible(false)
	}

	if (!visible) return null

	return (
		<div
			role="dialog"
			aria-modal="true"
			aria-label="Sommerpause-Hinweis"
			className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 backdrop-blur-sm">
			<div className="relative w-full max-w-sm overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-black/5">
				<div className="flex flex-col items-center gap-3 bg-primary px-8 pb-6 pt-8">
					<div className="flex size-14 items-center justify-center rounded-full bg-white/15">
						<CalendarOffIcon className="size-7 text-white" strokeWidth={1.75} />
					</div>
					<h2 className="text-lg font-semibold tracking-tight text-white">Sommerpause</h2>
				</div>

				<div className="px-8 pb-7 pt-6 text-center">
					<p className="text-sm leading-relaxed text-gray-600">
						Wir machen eine kleine Sommerpause vom
					</p>
					<p className="mt-1 text-2xl font-bold tracking-tight text-gray-900">13. – 18. Juli</p>
					<p className="mt-3 text-sm leading-relaxed text-gray-500">
						In dieser Zeit sind wir nicht erreichbar. Ab dem 20. Juli sind wir wieder für euch da!
					</p>

					<button
						onClick={handleClose}
						className="mt-6 w-full rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-white transition-opacity hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2">
						Alles klar!
					</button>
				</div>

				<button
					onClick={handleClose}
					aria-label="Schließen"
					className="absolute right-3 top-3 rounded-full p-1.5 text-white/70 transition-colors hover:bg-white/20 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/50">
					<XIcon className="size-4" />
				</button>
			</div>
		</div>
	)
}
